import { useEffect } from 'react';
import { Dialog, DialogContent, Divider, Grid } from '@mui/material';
import { Typography } from '@uhc-tempo/components';

const GenericModal = (props) => {
    const handleDisplayModal = () => {
        props.setShowModalDialog(!props.showModalDialog);
    };

    useEffect(() => {
        if (props.showModalDialog && document.getElementById(`${props.modalLabel}DialogChildDiv`)) {
            document.getElementById(`${props.modalLabel}DialogChildDiv`).focus();
        }
    }, [props.showModalDialog]);

    return (
        <Dialog
            open={props.showModalDialog}
            onClose={handleDisplayModal}
            data-testid={`${props.modalLabel}-modal`}
            maxWidth={'lg'}
            id={`${props.modalLabel}-dialog`}
            PaperProps={{
                tabIndex: -1,
                id: `${props.modalLabel}DialogChildDiv`,
                style: { overflowY: 'hidden' },
                'aria-labelledby': `${props.modalLabel}H2`,
            }}
        >
            <Grid item xs={12}>
                <div id={`${props.modalLabel}Header`}>
                    <Grid item xs={12}>
                        <Typography.H2 id={`${props.modalLabel}H2`} style={props.modalStyles.temp}>
                            {props.modalTitle}
                        </Typography.H2>
                    </Grid>
                </div>
            </Grid>
            <Grid item xs={12}>
                <button
                    className="tds-modal__close"
                    aria-label={`close ${props.modalLabel}`}
                    onClick={handleDisplayModal}
                    style={{ float: 'right' }}
                >
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        role="presentation"
                        className="tds-modal__close--icon"
                    >
                        <title>Close modal</title>
                        <defs>
                            <rect
                                id="modal_000_close"
                                x="0"
                                y="0"
                                width="14"
                                height="14"
                                rx="8"
                            ></rect>
                        </defs>
                        <g fill="none" fillRule="evenodd">
                            <path
                                d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
                                fill="#196ECF"
                            ></path>
                        </g>
                    </svg>
                </button>
            </Grid>

            <Divider style={props.modalStyles.divider} role="presentation" aria-hidden="true" />

            <DialogContent dividers={scroll === 'paper'} style={props.modalStyles.dialogContent}>
                {props.modalBody}
            </DialogContent>
        </Dialog>
    );
};

export default GenericModal;
